import { nextTick, onMounted } from 'vue'

export function useDialogContent(props) {
  function onInteractOutside(event) {
    if (
      props.isStaticBackdrop
      // fix conflict with sweet alert
      || event.target?.closest('.swal2-container')
      || event.target?.closest('.tox')
      || event.target?.closest('[aria-label]')
    ) {
      event.preventDefault()
    }
  }

  function onOpenAutoFocus(event) {
    event.preventDefault()

    nextTick(() => {
      // prevent pointer events none on body
      // https://github.com/unovue/reka-ui/issues/1540
      if (props.forceMount || props.isStaticBackdrop) {
        document.body.setAttribute('style', '')
      }
    })
  }

  onMounted(() => {
    if (props.forceMount || props.isStaticBackdrop) {
      document.body.setAttribute('style', '')
    }
  })

  return {
    onInteractOutside,
    onOpenAutoFocus,
  }
}
